import {
  type ItemTag,
  type OrderableItemKey,
  orderableItemValues,
} from "../orderableItems.js";

export const getOrderableItemKeysByTag = (tag: ItemTag) =>
  orderableItemValues
    .filter((item) => item.itemTags.some((itemTag) => itemTag === tag))
    .map((item) => item.key);

export const getOrderableItemsKeysByTagOrKey = (
  tagOrKey: ItemTag | OrderableItemKey,
) =>
  orderableItemValues
    .filter(
      (item) =>
        item.itemTags.some((itemTag) => itemTag === tagOrKey) ||
        item.key === tagOrKey,
    )
    .map((item) => item.key);
